import { useState, useEffect } from "react";
import axios from "axios";
import API_ENDPOINTS from "config/api";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";
import Chip from "@mui/material/Chip";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import DataTable from "examples/Tables/DataTable";
import { useMaterialUIController } from "context";

import RegistrarProveedor from "components/RegistrarProveedor";

// const API_URL = ... (removed)
const empresaId = localStorage.getItem("empresaId") || "1";

export default function Proveedores() {
  const [controller] = useMaterialUIController();
  const { sidenavColor } = controller;

  const [filtro, setFiltro] = useState("");
  const [proveedores, setProveedores] = useState([]);
  const [loading, setLoading] = useState(true);
  const [openRegistrar, setOpenRegistrar] = useState(false);

  // Cargar proveedores desde el backend
  useEffect(() => {
    fetchProveedores();
  }, []);

  const fetchProveedores = async () => {
    try {
      setLoading(true);
      const response = await axios.get(API_ENDPOINTS.PROVEEDORES, {
        params: { empresa_id: empresaId },
      });
      setProveedores(response.data);
    } catch (error) {
      console.error("Error al cargar proveedores:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleOpenRegistrar = () => setOpenRegistrar(true);
  const handleCloseRegistrar = () => setOpenRegistrar(false);

  // Datos filtrados para la tabla
  const proveedoresFiltrados = proveedores.filter((prov) =>
    prov.nombre?.toLowerCase().includes(filtro.toLowerCase())
  );

  const columns = [
    { Header: "Nombre", accessor: "nombre", width: "20%" },
    { Header: "RFC", accessor: "rfc", width: "15%" },
    { Header: "Contacto", accessor: "contacto", width: "15%" },
    { Header: "Teléfono", accessor: "telefono", width: "12%" },
    { Header: "Email", accessor: "email", width: "18%" },
    { Header: "Estatus", accessor: "estatus", align: "center", width: "8%" },
    { Header: "Acciones", accessor: "acciones", align: "center", width: "12%" },
  ];

  const rows = proveedoresFiltrados.map((prov) => ({
    nombre: prov.nombre || "",
    rfc: prov.rfc || "",
    contacto: prov.contacto || "",
    telefono: prov.telefono || "",
    email: prov.email || "",
    estatus: (
      <Chip
        label={prov.estatus === "activo" ? "Activo" : "Inactivo"}
        color={prov.estatus === "activo" ? "success" : "default"}
        size="small"
      />
    ),
    acciones: (
      <MDBox display="flex" gap={1} justifyContent="center">
        <Icon sx={{ cursor: "pointer", fontSize: 20 }} color="primary">
          edit
        </Icon>
        <Icon sx={{ cursor: "pointer", fontSize: 20 }} color="error">
          delete
        </Icon>
      </MDBox>
    ),
  }));

  return (
    <MDBox>
      <Grid container spacing={3} mb={3}>
        <Grid item xs={12} md={8}>
          <MDInput
            label="Buscar proveedor"
            fullWidth
            value={filtro}
            onChange={(e) => setFiltro(e.target.value)}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <MDButton
            variant="gradient"
            color={sidenavColor}
            fullWidth
            onClick={handleOpenRegistrar}
          >
            <Icon sx={{ mr: 1 }}>add</Icon>
            Nuevo Proveedor
          </MDButton>
        </Grid>
      </Grid>

      <Card>
        <MDBox p={3}>
          <MDTypography variant="h6" mb={2}>
            <Icon sx={{ mr: 1 }}>business</Icon>
            Lista de Proveedores ({proveedoresFiltrados.length})
          </MDTypography>
          {loading ? (
            <MDTypography variant="body2">Cargando proveedores...</MDTypography>
          ) : (
            <DataTable
              table={{ columns, rows }}
              showTotalEntries={true}
              isSorted={true}
              noEndBorder
              entriesPerPage={false}
            />
          )}
        </MDBox>
      </Card>

      <RegistrarProveedor
        open={openRegistrar}
        onClose={handleCloseRegistrar}
        onSuccess={fetchProveedores}
      />
    </MDBox>
  );
}
